/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { popupControllerCreate } from '../fn/popup/popup-controller-create';
import { PopupControllerCreate$Params } from '../fn/popup/popup-controller-create';
import { popupControllerDelete } from '../fn/popup/popup-controller-delete';
import { PopupControllerDelete$Params } from '../fn/popup/popup-controller-delete';
import { popupControllerFindById } from '../fn/popup/popup-controller-find-by-id';
import { PopupControllerFindById$Params } from '../fn/popup/popup-controller-find-by-id';
import { popupControllerGetPopupSettingByType } from '../fn/popup/popup-controller-get-popup-setting-by-type';
import { PopupControllerGetPopupSettingByType$Params } from '../fn/popup/popup-controller-get-popup-setting-by-type';
import { popupControllerReorder } from '../fn/popup/popup-controller-reorder';
import { PopupControllerReorder$Params } from '../fn/popup/popup-controller-reorder';
import { popupControllerSearch } from '../fn/popup/popup-controller-search';
import { PopupControllerSearch$Params } from '../fn/popup/popup-controller-search';
import { popupControllerUpdate } from '../fn/popup/popup-controller-update';
import { PopupControllerUpdate$Params } from '../fn/popup/popup-controller-update';
import { popupControllerUpdateSetting } from '../fn/popup/popup-controller-update-setting';
import { PopupControllerUpdateSetting$Params } from '../fn/popup/popup-controller-update-setting';
import { popupControllerUpdateStatus } from '../fn/popup/popup-controller-update-status';
import { PopupControllerUpdateStatus$Params } from '../fn/popup/popup-controller-update-status';
import { PopupDto } from '../models/popup-dto';
import { PopupSettingDto } from '../models/popup-setting-dto';
import { SearchResponsePopupDto } from '../models/search-response-popup-dto';

@Injectable({ providedIn: 'root' })
export class PopupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `popupControllerSearch()` */
  static readonly PopupControllerSearchPath = '/api/popups/search';

  /**
   * 팝업 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerSearch$Response(params: PopupControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponsePopupDto>> {
    return popupControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerSearch(params: PopupControllerSearch$Params, context?: HttpContext): Observable<SearchResponsePopupDto> {
    return this.popupControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchResponsePopupDto>): SearchResponsePopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerGetPopupSettingByType()` */
  static readonly PopupControllerGetPopupSettingByTypePath = '/api/popups/setting/{type}';

  /**
   * 팝업 셋팅 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerGetPopupSettingByType()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerGetPopupSettingByType$Response(params: PopupControllerGetPopupSettingByType$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupSettingDto>> {
    return popupControllerGetPopupSettingByType(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 셋팅 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerGetPopupSettingByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerGetPopupSettingByType(params: PopupControllerGetPopupSettingByType$Params, context?: HttpContext): Observable<PopupSettingDto> {
    return this.popupControllerGetPopupSettingByType$Response(params, context).pipe(
      map((r: StrictHttpResponse<PopupSettingDto>): PopupSettingDto => r.body)
    );
  }

  /** Path part for operation `popupControllerFindById()` */
  static readonly PopupControllerFindByIdPath = '/api/popups/{id}';

  /**
   * 팝업 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindById$Response(params: PopupControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    return popupControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerFindById(params: PopupControllerFindById$Params, context?: HttpContext): Observable<PopupDto> {
    return this.popupControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

  /** Path part for operation `popupControllerUpdate()` */
  static readonly PopupControllerUpdatePath = '/api/popups/{id}';

  /**
   * 팝업 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdate$Response(params: PopupControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return popupControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdate(params: PopupControllerUpdate$Params, context?: HttpContext): Observable<boolean> {
    return this.popupControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `popupControllerCreate()` */
  static readonly PopupControllerCreatePath = '/api/popups';

  /**
   * 새 팝업 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerCreate$Response(params: PopupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return popupControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 팝업 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerCreate(params: PopupControllerCreate$Params, context?: HttpContext): Observable<boolean> {
    return this.popupControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `popupControllerDelete()` */
  static readonly PopupControllerDeletePath = '/api/popups';

  /**
   * 팝업 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerDelete$Response(params: PopupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return popupControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupControllerDelete(params: PopupControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.popupControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `popupControllerUpdateStatus()` */
  static readonly PopupControllerUpdateStatusPath = '/api/popups';

  /**
   * 팝업 상태 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdateStatus$Response(params: PopupControllerUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return popupControllerUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 상태 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdateStatus(params: PopupControllerUpdateStatus$Params, context?: HttpContext): Observable<void> {
    return this.popupControllerUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `popupControllerUpdateSetting()` */
  static readonly PopupControllerUpdateSettingPath = '/api/popups/setting';

  /**
   * 팝업 설정 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerUpdateSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdateSetting$Response(params: PopupControllerUpdateSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return popupControllerUpdateSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 설정 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerUpdateSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerUpdateSetting(params: PopupControllerUpdateSetting$Params, context?: HttpContext): Observable<void> {
    return this.popupControllerUpdateSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `popupControllerReorder()` */
  static readonly PopupControllerReorderPath = '/api/popups/reorder';

  /**
   * 팝업 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupControllerReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerReorder$Response(params: PopupControllerReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return popupControllerReorder(this.http, this.rootUrl, params, context);
  }

  /**
   * 팝업 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupControllerReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  popupControllerReorder(params: PopupControllerReorder$Params, context?: HttpContext): Observable<boolean> {
    return this.popupControllerReorder$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
